




























import { Component, Mixins, Prop } from "vue-property-decorator";
import { Color, TextAlignKinds, TextStyle } from "../../domain/drawing";
import { ModelEditableMixin } from "../system/mixins";
import FontSizeDropDownSelector from "./FontSizeDropDownSelector.vue";
import TextAlignDropDownSelector from "./TextAlignDropDownSelector.vue";
import ColorPicker from "./ColorPicker.vue";
import Enumerable from "linq";
import { DomainRegistry } from "../../domain";
import { OptionDropDownSelector, ComboBoxSelector } from "../system/selectors";
import { StandardOption } from "../system/selectors/mixins";

@Component({
  components: {
    colorPicker: ColorPicker,
    textAlignSelector: TextAlignDropDownSelector,
    fontSizeSelector: FontSizeDropDownSelector,
    OptionDropDownSelector,
    ComboBoxSelector,    
  },
})
export default class TextStyleEditor extends Mixins(ModelEditableMixin) {
  editingSource: TextStyle;

  @Prop()
  pallet: Color[];

  @Prop({ default: "フォントサイズを選択します。" })
  fontSizeDescription: string;

  @Prop({ default: "文字列の配置(アライメント)を選択します。" })
  alignDescription: string;

  @Prop({ default: "文字の色を選択します。" })
  colorDescription: string;

  data() {
    return {
      fontsData: [] as string[],
    };
  }

  fontsData: string[]; 

  mounted() {
    if (this.fontFamilyEditable) {
      this.getFontData();
    }
  }

  get color(): Color {
    return this.editingSource
      ? this.editingSource.color
      : undefined;
  }

  set color(value: Color) {
    this.writeProperty(s => s.color = value);
  }

  get textAlign(): TextAlignKinds {
    return this.editingSource
      ? this.editingSource.textAlign
      : undefined;
  }

  set textAlign(value: TextAlignKinds) {
    this.writeProperty(s => s.textAlign = value);
  }

  get fontSize(): number {
    return this.editingSource
      ? this.editingSource.baseFontSize
      : undefined;
  }

  set fontSize(value: number) {
    this.writeProperty(s => {
      s.baseFontSize = value;
      s.adjustedFontSize = null;
    });
  }

  get fontFamilyEditable(): boolean {
    return this.$configuration.behavior.document.editor.contents.edit.textStyle.fontFamily.isEnable;
  }

  get fontFamily(): string {
    return this.editingSource
      ? this.editingSource.fontFamily
      : undefined;
  }

  set fontFamily(value: string) {
    this.writeProperty(s => s.fontFamily = value);
  }

  get defaultColor(): Color {
    return new Color("#000000");
  }

  equivalentValidator(source: string, destination: string): boolean {
    return !!source === !!destination && source === destination;
  }

  get fontOptions(): StandardOption<string>[] { 
    return Enumerable.from(this.fontsData).select(s => new StandardOption(s, s)).toArray();
  }

  async getFontData(): Promise<void> {
    try {
      const repository = DomainRegistry.document.getDocumentRepository();
      this.fontsData = await repository.getFontFamilyNames();
    } catch (e) {
      this.$logger.warn(e);
    }
  }  
}
